<template>
    <div id="apricationDD">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right;">
                    <el-button size="mini" @click="downloadedFile()"
                               style="background-color:#ffa526;color: white;">
                        下载<i class="el-icon-download"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handleCurrentChange()"
                               style="background-color:#409EFF;color: white;margin-right: 3px;">
                        查询<i class="el-icon-search"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-date-picker
                            @change="dateChang"
                            v-model="dateValues"
                            class="queryPzDate"
                            type="monthrange"
                            value-format="yyyy-MM"
                            align="right"
                            size="mini"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
            </div>
        </div>

        <el-table
                :data="tableData"
                height="520"
                border=""
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'left'}"
                size="mini"
                style="width: 100%; margin-bottom: 20px;">
            <el-table-column
                    width="220"
                    prop="kmdm"
                    label="科目编码"
                    align="center">
                <template slot-scope="scope">
                    <a class="kmdmCss" @click="handleMx(scope.row)">{{scope.row.kmdm}}</a>
                </template>
            </el-table-column>
            <el-table-column
                    width="320"
                    prop="kmmc"
                    label="科目名称"
                    align="center">
            </el-table-column>
            <el-table-column
                    class-name="ricss"
                    prop="jfje"
                    align="center"
                    label="借方金额（元）">
            </el-table-column>
            <el-table-column
                    class-name="ricss"
                    prop="dfje"
                    align="center"
                    label="贷方金额（元）">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        name: 'kmyebiaoList',
        data() {
            return {
                tableData: [],
                startTimeStr: null,
                endTimeStr: null,
                pickerOptions: {
                    shortcuts: [{
                        text: '本月',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            // 2.获取今日的年月
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            const end = new Date(year, month - 1, 1);
                            const start = new Date(year, month - 1, 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dateValues: []
            }
        },
        methods: {
            dateChang() {
                if (this.dateValues != null && this.dateValues.length > 0) {
                    this.startTimeStr = this.dateValues[0];
                    this.endTimeStr = this.dateValues[1];
                } else {
                    this.startTimeStr = null;
                    this.endTimeStr = null;
                }
            },
            handleCurrentChange() {
                this.tableData = [];
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/pzHzbList?td=' + new Date()),
                    method: 'get',
                    params: {
                        'startTimeStr': this.startTimeStr,
                        'endTimeStr': this.endTimeStr
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.dataList;
                        this.dateValues = r.data.data.dateValues;
                    } else {
                        this.$message({
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                }).finally(r => {
                })

            },
            handleMx(row) {
                let kmdm = row.kmdm;
                let kmmc = row.kmmc;
                this.$router.push({
                    path: '/home-mxz/list',
                    query: {
                        kmdm: kmdm,
                        kmmc: kmmc,
                        dateValues: this.dateValues
                    }
                })
            },
            downloadedFile(){
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/pzHzbList?td=' + new Date()),
                    method: 'get',
                    responseType:'blob',   //返回类型
                    params: {
                        'startTimeStr': this.startTimeStr,
                        'endTimeStr': this.endTimeStr,
                        'blob': "true"
                    }
                }).then(data => {

                    //通过返回的二进制流创建 Blob对象
                    let blob = new Blob([data.data],
                        {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                    );
                    let url = window.URL.createObjectURL(blob);
                    //方式一：该url就是由返回的二进制流创建的文件下载地址，可以直接使用 window.location.href = url;下载
                    //不过下载后需要手动修改文件名和后缀名

                    //方式二：触发浏览器的内置下载功能
                    let a = document.createElement('a')//创建一个a标签元素
                    a.style.display = 'none'//设置为不显示
                    a.href = url    //设置a标签的href属性
                    a.setAttribute('download', '凭证汇总表.xlsx')//设置下载的文件名
                    document.body.appendChild(a)//将a标签元素加入到页面中
                    a.click()//触发点击
                    document.body.removeChild(a) // 下载完成移除元素
                    window.URL.revokeObjectURL(url) // 释放掉blob对象

                }).finally(r => {
                })
            }
        },
        created: function () {
            this.handleCurrentChange();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .el-collapse-item div {
        padding-left: 20px;
        padding-bottom: 15px;
    }

    #apricationDD >>> .el-table--border td, .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table--border th {
        border-right: 1px solid #ddd !important;
        border-top: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table {
        border-right: 1px solid #ddd !important;
        border-left: 1px solid #ddd !important;
    }

    .queryPzDate {
        margin-right: 5px;
    }

    #apricationDD >>> tbody .ricss {
        text-align: right !important;
    }

    .kmdmCss {
        color: #3cbaff;cursor: pointer;
    }
    #apricationDD >>> .el-table tr:hover {
        text-decoration:underline;
        text-decoration-color: #78848b;
    }
</style>